import { render, staticRenderFns } from "./SignupNew.vue?vue&type=template&id=5d0b8868&scoped=true&"
import script from "./SignupNew.vue?vue&type=script&lang=js&"
export * from "./SignupNew.vue?vue&type=script&lang=js&"
import style0 from "./SignupNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SignupNew.vue?vue&type=style&index=1&id=5d0b8868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b8868",
  null
  
)

export default component.exports